import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DatePipe, DecimalPipe } from "@angular/common";
import { APIURL } from "app/Shared/Constant/API_Urls";
import { UrlsService } from "app/Shared/Services/urls.service";
import { UserService } from "app/Shared/Services/user.service";
import { SharedHttpClientService } from "app/Shared/Services/shared-http-client.service";
import { EmitterService } from "app/Shared/Services/emitter.service";
import { Subscription } from "rxjs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
  selector: 'app-firm-wide-cat-summary',
  imports: [MatProgressSpinnerModule, FormsModule, MatTooltipModule, DecimalPipe, TableModule, DatePickerModule],
  templateUrl: './firm-wide-cat-summary.component.html',
  styleUrl: './firm-wide-cat-summary.component.scss'
})
export class FirmWideCatSummaryComponent implements OnInit, OnDestroy {
  isLoadingResults!: boolean;
  tbldatamsg: string = 'No data found';
  public transactionData: any = [];
  private subscription: Subscription | any;
  LastCATExecutionDate: any = new Date();

  constructor(
    private router: Router,
    private UrlsService: UrlsService,
    private UserService: UserService,
    private datePipe: DatePipe,
    private SharedHttpClientService: SharedHttpClientService,
    private EmitterService: EmitterService) {
  }

  ngOnInit() {
    this.LastCATExecutionDate = (this.UserService.CATDashboard_LastExecutionDate ? this.UserService.CATDashboard_LastExecutionDate : new Date());
    if (this.LastCATExecutionDate) {
      this.getData();
      this.subscription = this.EmitterService.reloadMainDashBoard.subscribe(value => {
        if (value) {
          this.isLoadingResults = true;
          this.UserService.get_CAT_Last_ReportDate().subscribe((res: any) => {
            let response: any = res;
            let jsondata = response.data[0]
            if(jsondata) {
              this.LastCATExecutionDate = jsondata.CATLastExcecutionReportDate !=="" ? this.UserService.getFormatedDate(jsondata.CATLastExcecutionReportDate) : new Date();
              this.getData();
            }
          });
        }
      });
    }
  }

  getData() {
    this.isLoadingResults = true;
    this.SharedHttpClientService.get(
      this.UrlsService.setAPIURl3(
        APIURL.CAT_Dash_Firmwide_Summary,
        this.UserService.getActiveMPID(),
        this.UserService.getUserName(),
        this.datePipe.transform(this.LastCATExecutionDate, 'yyyy-MM-dd')
      )
    )
    .subscribe({
      next: (data: any) => {
        this.isLoadingResults = false;
        this.transactionData = data;
      },
      error: (e) => {
          console.error(e);
          this.isLoadingResults = false;
      }
    });
  }

  clickLeft() {
    let yesterday = new Date(new Date(this.LastCATExecutionDate).setDate(new Date(this.LastCATExecutionDate).getDate()-1));
    this.LastCATExecutionDate = this.UserService.getUTCDate_yyyyMMdd(yesterday);
    this.getData();
  }

  clickRight() {
    let tomorrow =  new Date(new Date(this.LastCATExecutionDate).setDate(new Date(this.LastCATExecutionDate).getDate()+1));
    this.LastCATExecutionDate = this.UserService.getUTCDate_yyyyMMdd(tomorrow);
    this.getData();
  }

  goToScreenViewer(rowData: any, screenType: any) {
    if(screenType && screenType==="CAT-ROE") {

      let urlParams = {
        "callFromScreen": "CAT-Transaction-Statistics",
        "reportDate": this.UserService.getyyyyMMddDateFormate(this.LastCATExecutionDate),
        "activeMPID": rowData.CATReporterIMID
      };

      /* Catch User Action Log */
      this.UserService.logUserActivity("Reviewed CAT-ROE Records", null, {
        'Text1': this.UserService.userFirstName + ' reviewed CAT-ROE records from CAT-Transation Statistics',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(urlParams)
      });
 
      this.router.navigate([]).then(result => {  window.open('/#/pages/CAT/CAT-ROE-Viewer?'+btoa(JSON.stringify(urlParams)), '_blank'); });

    } else if(screenType && screenType==="FINRA-EXCEPTION") {

      let initialReportDate = this.UserService.getFormatedDate(this.UserService.getyyyyMMddDateFormate(this.LastCATExecutionDate));
      let endReportDate = this.UserService.getFormatedDate(this.UserService.getyyyyMMddDateFormate(this.LastCATExecutionDate));

      let urlParams = {
        "callFromScreen": "CAT-Transaction-Statistics",
        "activeMPID": rowData.CATReporterIMID,
        "reportDate": [initialReportDate, endReportDate],
        "modifiedFlag": ['N', 'U', 'C']
      };

      /* Catch User Action Log */
      this.UserService.logUserActivity("Reviewed Finra-Exception Records", null, {
        'Text1': this.UserService.userFirstName + ' reviewed Finra-Exception records from CAT-Transation Statistics',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(urlParams)
      });

      this.router.navigate([]).then(result => {  window.open('/#/pages/CAT/Finra-Exception?'+btoa(JSON.stringify(urlParams)), '_blank'); });

    }

  }

  ngOnDestroy() {
    if(this.subscription)
      this.subscription.unsubscribe();
  }

}
